export const normalizarIdentificacion = (valor: unknown) =>
  String(valor ?? '').replace(/\s/gu, '')

export const coincideIdentificacion = (
  persona: { copeTipoIdentificacion?: number | null; copeIdentificacion?: string | null },
  tipo: number,
  numero: string
) =>
  Number(persona.copeTipoIdentificacion) === Number(tipo) &&
  normalizarIdentificacion(persona.copeIdentificacion) === numero
